// Libraries
import React from 'react';

// Supermove
import {DataLoader, Form, Space, Styled} from '@supermove/components';
import {gql, useQuery} from '@supermove/graphql';
import {DocumentItemInputSavePaymentType, PaymentMethodModel, UserModel} from '@supermove/models';

// App
import Text from '@shared/design/components/Text';

const LoadingIndicator = Styled.Loading`
`;

const Row = Styled.View`
  flex-direction: row;
  align-items: center;
`;

const DocumentV2SavePaymentInputNoPaymentMethod = () => {
  return (
    <React.Fragment>
      <Text.Body>Please contact {'{COMPANY_NAME}'} to make your payment.</Text.Body>
    </React.Fragment>
  );
};

const DocumentV2SavePaymentInputBody = ({
  input,
  form,
  field,
  isEditable,
  isRequired,
  paymentMethod,
}: {
  input: DocumentItemInputSavePaymentType['input'];
  form: Form;
  field: string;
  isEditable: boolean;
  isRequired: boolean;
  paymentMethod: PaymentMethodModel;
}) => {
  return (
    <React.Fragment>
      <Text.Subheading>Payment Method</Text.Subheading>
      <Space height={8} />
      <Row>
        <Text.Label>{paymentMethod.name}</Text.Label>
        <Space width={32} />
        <Text.Body>Visa •••• 0000</Text.Body>
      </Row>
      <Space height={8} />
      <Text.Micro>Your card will not be charged at this time.</Text.Micro>
    </React.Fragment>
  );
};

const DocumentV2SavePaymentInput = ({
  input,
  form,
  field,
  isEditable,
  isRequired,
}: {
  input: DocumentItemInputSavePaymentType['input'];
  form: Form;
  field: string;
  isEditable: boolean;
  isRequired: boolean;
}) => {
  const {paymentMethodIds} = input.metadata;
  const paymentMethodId = paymentMethodIds.length > 0 ? paymentMethodIds[0] : null;

  const {data, loading} = useQuery<{
    viewer: UserModel;
  }>(DocumentV2SavePaymentInput.query, {
    variables: {paymentMethodId},
    skip: !paymentMethodId,
  });

  if (!paymentMethodId) {
    return <DocumentV2SavePaymentInputNoPaymentMethod />;
  }

  return (
    <DataLoader data={data} loading={loading} as={LoadingIndicator}>
      {({loadedData}) =>
        loadedData.viewer.viewingOrganization.paymentMethod ? (
          <DocumentV2SavePaymentInputBody
            input={input}
            form={form}
            field={field}
            isEditable={isEditable}
            isRequired={isRequired}
            paymentMethod={loadedData.viewer.viewingOrganization.paymentMethod}
          />
        ) : (
          <DocumentV2SavePaymentInputNoPaymentMethod />
        )
      }
    </DataLoader>
  );
};

DocumentV2SavePaymentInput.query = gql`
  query DocumentV2SavePaymentInput($paymentMethodId: Int!) {
    viewer {
      id
      viewingOrganization {
        id
        paymentMethod(paymentMethodId: $paymentMethodId) {
          id
          name
        }
      }
    }
  }
`;

export default DocumentV2SavePaymentInput;
